import React, { useEffect, useState } from 'react'
import './input-search.scss'
import searchIcon from '../../../assets/images/icons/search.svg'
import closeIcon from '../../../assets/images/icons/mask.svg'
import { graphql, useStaticQuery } from "gatsby";
import siteUrl from '../../../utils/siteUrl'
import { eventPushGTM } from '../../../utils/utilGtm';

const InputSearch = props => {
    const { setparentResult, setparentsearchValue, isPageSearcher, gtm } = props

    const RX_INPUT = /^[ a-zA-Z0-9#°áéíóúÁÉÍÓÚäëïöüÄËÏÖÜñÑ,.;:()¿?¡!_-]+$/
    const slugToValidate = '/buscador/'

    const { allContentfulSubproducto,
        allContentfulPreguntaFrecuente,
        contentfulInformacionGeneral,
        allContentfulSegmento,
        allContentfulProducto,
        allContentfulPromocion,
        allContentfulBien,
        allContentfulSegmentoCategoria,
        allContentfulEvento,
        allContentfulPaginaCompleta
    } = useStaticQuery(
        graphql`
            {
                contentfulInformacionGeneral {
                    marcaDeAgua
                    sugerencias {
                        titulo
                        enlace
                    }
                    redireccionesAutomaticas {
                        titulo
                        enlace
                        descripcion
                    }
                }

                allContentfulProducto {
                    nodes {
                      metaTitulo
                      metaImagen {
                        description
                        file {
                          url
                        }
                      }
                      metaDescripcion
                      slug
                      categoriaPrincipal {
                        slug
                        segmento {
                          slug
                        }
                      }
                    }
                }

                allContentfulPaginaCompleta {
                    nodes {
                      metaTitulo
                      metaDescripcion
                      metaImagen {
                        file {
                          url
                        }
                        description
                      }
                      slug
                    }
                  }

                allContentfulSubproducto {
                    nodes {
                        metaTitulo
                        metaDescripcion
                        metaImagen {
                        description
                            file {
                                url
                            }
                        }
                        score
                        slug
                        producto {
                            slug
                            subproducto{
                                slug
                            }
                            categoriaPrincipal {
                                slug
                                segmento {
                                    slug
                                }
                            }
                        }
                    }
                }

                allContentfulPreguntaFrecuente {
                    nodes {
                        pregunta
                        respuestas {
                            raw
                        }
                    }
                }
                allContentfulSegmento {
                    nodes {
                        metaTitulo
                        metaDescripcion
                        imagenPrevia {
                        description
                            file {
                                url
                            }
                        }
                        slug
                    }
                }

                allContentfulPromocion {
                    nodes {
                        slug
                        metaDescripcion
                        metaTitulo
                        metaImagen {
                            description
                            file {
                                url
                            }
                        }
                    }
                }
            
                allContentfulBien {
                    nodes {
                        slug
                        tipoDeBien
                        metaDescripcion
                        metaTitulo
                        metaImagen {
                            file {
                                url
                            }
                        }
                    }
                }

                allContentfulSegmentoCategoria {
                    nodes {
                        metaDescripcin
                        metaTitulo
                        metaImagen {
                            file {
                                url
                            }
                        }
                        slug
                        segmento {
                          slug
                        }
                    }
                }

                allContentfulEvento {
                    nodes {
                      imagen {
                        file {
                          url
                        }
                      }
                      titulo
                      descripcion
                    }
                  }
            }
          
          `
    );

    const { marcaDeAgua, sugerencias, redireccionesAutomaticas } = contentfulInformacionGeneral
    const suggestList = sugerencias.map(e => ({ metaTitulo: e.titulo, slug: e.enlace, isSuggest: true }))
    const autoRedirectList = redireccionesAutomaticas.map(e => ({ metaTitulo: e.titulo, slug: e.enlace, isAutoRedirect: true, metaDescripcion: e.descripcion}))

    const getInfoToSearch = () => {
        var infoToSearch = []

        const subproductosAux = allContentfulSubproducto.nodes
        var subproductos = subproductosAux.map(function (el) {
            var o = Object.assign({}, el);
            o.contentType = "subproductos";
            return o;
        }).filter(e => e.producto !== null)

        // const productosAux = allContentfulProducto.nodes
        // var productos = productosAux.map(function (el) {
        //     var o = Object.assign({}, el);
        //     o.contentType = "productos";
        //     return o;
        // })

        const categoriasAux = allContentfulSegmentoCategoria.nodes
        var categorias = categoriasAux.map(function (el) {
            var o = Object.assign({}, el);
            o.contentType = "categorias";
            return o;
        })

        const segmentosAux = allContentfulSegmento.nodes
        var segmentos = segmentosAux.map(function (el) {
            var o = Object.assign({}, el);
            o.contentType = "segmentos";
            return o;
        })

        const preguntasFrecuentesAux = allContentfulPreguntaFrecuente.nodes.map(e => ({ metaTitulo: e.pregunta, ...e }))
        var preguntasFrecuentes = preguntasFrecuentesAux.map(function (el) {
            var o = Object.assign({}, el);
            o.contentType = "preguntasFrecuentes";
            return o;
        })

        const promocionesAux = allContentfulPromocion.nodes
        var promociones = promocionesAux.map(function (el) {
            var o = Object.assign({}, el);
            o.contentType = "promociones";
            return o;
        })

        const eventosAux = allContentfulEvento.nodes
        var eventos = eventosAux.map(
            e => (
                {
                    metaDescripcion: e.descripcion,
                    metaTitulo: e.titulo,
                    metaImagen: e.imagen
                }
            )
        ).map(function (el) {
            var o = Object.assign({}, el);
            o.contentType = "eventos";
            return o;
        })

        const bienesAux = allContentfulBien.nodes
        var bienes = bienesAux.map(function (el) {
            var o = Object.assign({}, el);
            o.contentType = "bienes";
            return o;
        })

        const paginasCompletasAux = allContentfulPaginaCompleta.nodes
        var paginasCompletas = paginasCompletasAux.map(function (el) {
            var o = Object.assign({}, el);
            o.contentType = "paginasCompletas";
            return o;
        })

        const autoRedirectsAux = autoRedirectList
        var autoRedirects = autoRedirectsAux.map(function (el) {
            var o = Object.assign({}, el);
            o.contentType = "autoRedireccion";
            o.score = 101;
            return o;
        })


        return infoToSearch = infoToSearch
            .concat(subproductos)
            // .concat(productos)
            .concat(preguntasFrecuentes)
            .concat(segmentos)
            .concat(autoRedirects)
            .concat(promociones)
            .concat(bienes)
            .concat(categorias)
            .concat(paginasCompletas)
            .concat(eventos)
        // .map(e => ({ oneLineData: JSON.stringify(e), ...e }))
    }

    const [searchValue, setsearchValue] = useState('')
    const [isSearcherPage, setisSearcherPage] = useState(false)
    const [resultSearch, setresultSearch] = useState(null)
    const [inputFocused, setinputFocused] = useState(false)

    useEffect(() => {
        let isSearcher = window.location.pathname === slugToValidate && isPageSearcher

        setisSearcherPage(isSearcher)
        if (isSearcher) {
            handleInitSearch()
        }
    }, [])

    const regularTransform = value => {
        return value.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    }

    const handleSubmit = e => {
        e && e.preventDefault()

        window.document.activeElement.blur();

        let filteredAutoredirectItem = autoRedirectList.filter(e => regularTransform(e.metaTitulo) === regularTransform(searchValue))[0]

        if (filteredAutoredirectItem) {
            window.location.href = siteUrl + '/' + filteredAutoredirectItem.slug + '/'
        } else {
            if (isSearcherPage) {
                window.document.getElementById('o-result-search').scrollIntoView();
            } else {
                window.location.href = siteUrl + slugToValidate + '?s=' + searchValue
            }
        }
    }

    const handleInitSearch = () => {
        let url_string = window.location.href;
        let url = new URL(url_string);
        let word = url.searchParams.get("s");

        if (word && (RX_INPUT).test(word)) {
            setsearchValue(word)
            setparentsearchValue && setparentsearchValue(word)
            handleSearcher(word)
        } else {
            setsearchValue('')
        }
    }

    const handleInputChange = value => {
        setsearchValue(value)
        setparentsearchValue && setparentsearchValue(value)

        handleSearcher(value)
    }

    const compare = (a, b) => {
        if (a.score > b.score) return -1;
        if (b.score > a.score) return 1;
        if (!b.score || !a.score) return 1;

        return 0;
    }

    const handleSearcher = value => {
        var copyList = getInfoToSearch();
        if (value !== '') {

            let checkName = (name, str) => {
                var pattern = str.split(" ").map((x) => {
                    return `(?=.*${x})`
                }).join("");

                var regex = new RegExp(`${pattern}`, "g")
                return name.match(regex);
            }

            let result = copyList.filter(item => {
                return Object.keys(item).some(key => {
                    if (item[key]) {
                        let arrayItem = regularTransform(item[key])
                        let inputValue = regularTransform(value)

                        return (
                            item[key] && ((arrayItem.search(inputValue) !== -1) || (checkName(arrayItem, inputValue) !== null))
                        )
                    }
                })
            })

            result.sort(compare)

            setresultSearch(result)
            setparentResult && setparentResult(result)
        } else {
            setresultSearch(suggestList)
            setparentResult && setparentResult(null)
        }
    }

    const handleEmptyFocus = () => {
        if (searchValue === '') {
            setresultSearch(suggestList)
        }
    }

    const handleSuggestClick = item => {
        let { slug, metaTitulo, isSuggest, isAutoRedirect } = item

        if (isSuggest || isAutoRedirect) {
            const isExternal = slug.includes('http');

            if (isExternal) {
                window.open(slug, '_blank');
            } else {
                window.location.href = siteUrl + '/' + slug
            }
        } else {
            if (isSearcherPage) {
                handleSubmit()
                setsearchValue(metaTitulo)
                setparentsearchValue && setparentsearchValue(metaTitulo)
                handleSearcher(metaTitulo)
            } else {
                window.location.href = siteUrl + '/buscador/?s=' + metaTitulo
            }
        }
    }

    const handleClearInput = () => {
        setsearchValue('')
        setresultSearch(null)
    }

    return (
        <form onSubmit={handleSubmit} className="a-input-search-form">
            <input
                className={"a-input-search-input " + (resultSearch && resultSearch.length === 0 ? 'error' : '')}
                placeholder={marcaDeAgua}
                onChange={e => {
                    if (!(RX_INPUT).test(e.target.value) && e.target.value !== '') {
                        return false;
                    } else {
                        handleInputChange(e.target.value.replace(/ {2}/g, ' '))
                        if(gtm){ eventPushGTM( gtm, 'ClickInputBusqueda', e.target.value.replace(/ {2}/g, ' ') ); }
                    }                    
                }}
                
                value={searchValue}
                onPaste={e => e.preventDefault()}
                onFocus={() => {
                    setinputFocused(true);
                    handleEmptyFocus()
                }}
                onBlur={() => {

                    setTimeout(() => {

                        setinputFocused(false)
                    }, 500);
                }}

            />
            {resultSearch && resultSearch.length === 0 &&
                <div className="a-input-search-error">
                    Asegúrate que la búsqueda esté escrita correctamente o intenta con una frase o
                    palabra clave diferente
                </div>
            }
            {searchValue &&
                <div className="a-input-search-clear-button" onClick={() => handleClearInput()}>
                    <img
                        className="a-input-search-clear-button-icon"
                        src={closeIcon}
                        alt="Ícono de borrado"
                    />

                </div>
            }
            <div className="a-input-search-button" onClick={handleSubmit}>
                <img
                    className="a-input-search-button-icon"
                    src={searchIcon}
                    alt="Ícono de buscador"
                />
            </div>
            {resultSearch && resultSearch.length !== 0 && inputFocused &&
                <div className="a-input-search-list-suggest">
                    <div className="a-input-search-list-suggest-title">
                        Búsquedas sugeridas
                    </div>
                    {resultSearch.slice(0, 5).map((item, index) => {
                        return (
                            <div className="a-input-search-list-suggest-item" onClick={
                                () =>{ 
                                    handleSuggestClick(item) 
                                    if(gtm){ eventPushGTM( gtm, 'ClickInputBusqueda', item.metaTitulo ); }
                                }
                            } key={index}>
                                {item.metaTitulo}
                            </div>
                        )
                    })}
                </div>
            }
        </form>
    )
}

export default InputSearch
